<script>
  import { onMount, onDestroy } from "svelte"
  import templateStore, { templateToJSON, jsonToTemplate } from "../../../../../Stores/metadataStore"
  import { removeEmptyKeys } from "../../../../../Script/removeEmptyKey"
  import MetadataSection from "./metadataSection.svelte"

  /**
   * @typedef json - The JSON object that will be modified and used for template data.
   * @type {json}
   */
  let json = {}

  /**
   * Function to unsubscribe from store updates.
   * @type {function}
   */
  let unsubscribe

  /**
   * Subscribes to the store and initializes the JSON object if it is empty.
   */
  onMount(() => {
    // If the JSON object is empty (no keys), subscribe to the templateStore.
    if (!Object.keys(json).length) {
      // Subscribe to the templateStore's updates and update the JSON object.
      unsubscribe = templateStore.subscribe((templateData) => {
        //updates json data by assigning tempateDate in json format
        json = templateToJSON(templateData)
      })
    }
  })

  /**
   * Cleans up and updates the store's template data when the component is destroyed.
   */
  onDestroy(() => {
    // Unsubscribe from the templateStore's updates.
    unsubscribe()

    // Update the templateStore's data based on the modified JSON object.
    templateStore.update((templateData) => {
      // Update the JSON object by converting the template data to JSON.
      json = templateToJSON(templateData)

      // Remove any empty keys from the JSON object.
      removeEmptyKeys(json)

      // Convert the modified JSON object back to template data.
      return jsonToTemplate(json)
    })
  })
</script>

{#each Object.entries(json) as [key, value]}
  <MetadataSection json={value} namespace={key} />
{/each}
